import React, { MouseEvent, ReactElement } from "react";
import { Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import { TableColumn } from "./types";
import { Icon } from "../icons/Icon";
import TableFilter from "./TableFilter";
import { IconButton } from "../inputs/IconButton";
import { SearchField } from "../inputs/SearchField";

const styles = (theme: Theme) =>
  createStyles({
    highlight: {
      color: theme.palette.secondary.main,
      backgroundColor: lighten(theme.palette.secondary.light, 0.85)
    },
    root: {
      paddingRight: theme.spacing(1)
    },
    spacer: {
      flex: "1 1 100%"
    },
    title: {
      flex: "0 0 auto"
    }
  });

type Props = {
  classes: any;
  columns: TableColumn[];
  filterFields?: ReactElement;
  numSelected: number;
  onFilterReset?: () => void;
  onFilterSubmit?: () => void;
  onSearchUpdate?: (e: any) => void;
  onSearchSubmit?: () => void;
  onSearchReset?: () => void;
  searchValue?: string;
  selectedAction: ((event: MouseEvent<any>) => void) | undefined;
  selectedActionIcon?: string;
};

type State = {};

class TableToolbar extends React.Component<Props, State> {
  render() {
    const {
      classes,
      filterFields,
      onFilterReset,
      onFilterSubmit,
      onSearchSubmit,
      onSearchUpdate,
      onSearchReset,
      numSelected,
      searchValue,
      selectedAction,
      selectedActionIcon = "delete"
    } = this.props;
    return (
      <Toolbar
        className={classNames(classes.root, {
          [classes.highlight]: numSelected > 0
        })}
      >
        <div className={classes.title}>
          {numSelected > 0 && (
            <Typography color="inherit" variant="subtitle1">
              {numSelected} selected
            </Typography>
          )}
        </div>
        <div className={classes.spacer} />
        {this.props.onSearchSubmit && (
          <SearchField
            onUpdate={onSearchUpdate}
            onSubmit={onSearchSubmit}
            onReset={onSearchReset}
            value={searchValue}
          />
        )}
        {numSelected > 0 && (
          <Tooltip title="Delete">
            <IconButton
              id="delete"
              aria-label="Delete"
              onClick={selectedAction}
            >
              {selectedActionIcon && <Icon name={selectedActionIcon} />}
            </IconButton>
          </Tooltip>
        )}
        {onFilterSubmit && filterFields && (
          <TableFilter
            filterFields={filterFields}
            onFilterReset={onFilterReset}
            onFilterSubmit={onFilterSubmit}
          />
        )}
      </Toolbar>
    );
  }
}

export default withStyles(styles)(TableToolbar);
